import { Address } from 'types/address'

export const parseAddress = (
  address: Pick<Address, 'line_1' | 'line_2' | 'city' | 'country' | 'postcode'>
) => {
  const { line_1, line_2, city, country, postcode } = address

  const toString = () => {
    return [line_1, line_2, city, country, postcode]
      .filter((part) => !!part)
      .join('\n')
  }

  return {
    ...address,
    toString
  }
}
